import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { BookOpenText } from 'lucide-react'
import { useTranslation } from 'react-i18next'

// 竞赛/活动规则 PDF（取 assets/document 下首个 PDF），登录页「活動介紹」按钮弹窗复用
const rulesPdfModules = import.meta.glob('../assets/document/*.pdf', { eager: true, query: '?url', import: 'default' });
const rulesPdfUrl = Object.values(rulesPdfModules)[0] as string;

// 把传入的子元素作为 DialogTrigger，点击后弹出比赛/活动详情 PDF。
// 登录页顶部「活動介紹」胶囊与其他入口共用同一份内容。
export function CompetitionRulesDialog({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-3xl h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg font-semibold">
            <BookOpenText className="h-5 w-5 text-primary" />
            {t("user.competition-rules-title")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto rounded-lg border">
          <iframe
            src={rulesPdfUrl}
            className="w-full h-full"
            title={t("user.competition-rules-title")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default CompetitionRulesDialog;
